import {useEffect, useState} from "react";
import {getAllMenuItemsNotInWeeklyMenu} from "../../Services/MenuItemService";
import {addWeeklyItem} from "../../Services/WeeklyMenuService";
import {Dish} from "../../Types/Dish";
import {AiOutlinePlusSquare} from "react-icons/ai";

type Props = {
  onSaved: () => void;
};

function AddWeeklyItemBody({onSaved}: Props) {
  const [dishes, setDishes] = useState<Dish[]>([]);
  const [amounts, setAmounts] = useState<Record<number, number>>({});

  useEffect(() => {
    loadDishes();
  }, []);

  const loadDishes = async () => {
    try {
      const data = await getAllMenuItemsNotInWeeklyMenu();

      setDishes(data);

      const initialAmounts: Record<number, number> = {};

      data.forEach((dish) => {
        if (dish.id !== undefined) {
          initialAmounts[dish.id] = 1;
        }
      });

      setAmounts(initialAmounts);
    } catch (err) {
      console.error(err);
      alert("Kon gerechten niet ophalen");
    }
  };

  const handleAmountChange = (menuItemId: number, value: number) => {
    setAmounts((prev) => ({
      ...prev,
      [menuItemId]: value < 1 ? 1 : value,
    }));
  };

  const handleAdd = async (dish: Dish) => {
    if (dish.id === undefined) {
      console.error("Menu item has no ID");
      return;
    }

    try {
      const amount = amounts[dish.id] ?? 1;

      await addWeeklyItem({
        menuItemId: dish.id,
        dishAmount: amount,
      });

      onSaved();
    } catch (err) {
      console.error(err);
      alert("Gerecht toevoegen aan weekmenu mislukt");
    }
  };

  return (
    <form>
      <h2 className="header-1">Gerecht toevoegen</h2>

      <p className="popup-description">
        Kies een gerecht om toe te voegen aan het weekmenu. 
        De items worden 1 voor 1 toegevoegd, dus zet niet eerst alle aantallen, dit zal verdwijnen zodra de eerste toegevoegd wordt.
      </p>

      <div className="simple-table-wrapper">
        <table className="simple-table">
          <thead>
            <tr>
              <th>Naam</th>
              <th>Aantal</th>
            </tr>
          </thead>

          <tbody>
          {dishes.map((dish) => {
            if (dish.id === undefined) {
              return null;
            }

            return (
              <tr key={dish.id}>
                <td>{dish.name}</td>

                <td>
                  <input
                    type="number"
                    min={1}
                    value={amounts[dish.id] ?? 1}
                    onChange={(e) =>
                      handleAmountChange(
                        dish.id!,
                        Number(e.target.value)
                      )
                    }
                    className="input-field input-field--small"
                  />
                </td>

                <td>
                  <button
                    type="button"
                    onClick={() => handleAdd(dish)}
                    className="table-button">
                    <AiOutlinePlusSquare size={25}/>
                  </button>
                </td>
              </tr>
            );
          })}
          </tbody>
        </table>
      </div>
    </form>
  );
}

export default AddWeeklyItemBody;
